import Util from './util';
import Global from './global';
import Logger from './logger'
import Constants from './constants';
import {postMessage} from './event-bus';
import {userInfoApi, departmentApi, kickOnlineUserApi} from '../src/service/person';
import {menuApi} from '../src/service/menu';

let auth = {};
auth.setWhiteRouteList = function(items){
  this.routeWhiteList = items;
};

auth.isWhiteRoute = function(path){
  let result = false;
  if(path === '/kiaf/log' || path === '/kiaf/sso' || path === '/kiaf/version' || path === '/kiaf/homepage'){
    result = true;
  } else if(Global.getCustomConfig()['LOGOUT_PAGE'] && Global.getCustomConfig()['LOGOUT_PAGE'].indexOf(path) == (Global.getCustomConfig()['LOGOUT_PAGE'].length - path.length)){
    result = true;
  }else if(this.routeWhiteList){
    this.routeWhiteList.forEach(item => {
      if(item === path){
        result = true;
      }
    });
  }
  return result;
};

auth.setUserInfo = function(userInfo){
	Global.setUserInfo(userInfo);
};

auth.getUserInfo = function() {
	return Global.getUserInfo();
};

auth.STORAGE_WHITE_LIST = [];//不清除白名单

auth.clearStorage = function(arr) {
  let flag = auth.getRememberUser();
  let whiteList = [Constants.STORAGE_KEY_SCREEN_COUNT, Constants.STORAGE_KEY_REMEMBER_ME, Constants.STORAGE_KEY_THEME].concat(auth.STORAGE_WHITE_LIST);
  if(flag){
    whiteList.push(Constants.STORAGE_KEY_USER_INFO);
  }
  if(arr){
    arr.forEach(item => {
      whiteList.push(item);
    });
  }
  for(let key in localStorage){
    if(key.indexOf(Global.getAppName()) === 0 && whiteList.indexOf(key) < 0){
      localStorage.removeItem(key);
    }
  }
	//session Storage不可以全部清空，一些是否是浏览器插件窗口的信息标记在sessionStorage
  sessionStorage.removeItem(Constants.STORAGE_KEY_FIRST_LOAD);
  sessionStorage.removeItem(Constants.STORAGE_KEY_WEBVIEW_PAGE);
  sessionStorage.removeItem(Constants.STORAGE_KEY_LAST_ACTIVE_TAG);
  sessionStorage.removeItem(Constants.STORAGE_KEY_LAST_ACTIVE_ID);
};

auth.clearCache = function() {
  let cacheList = [Constants.STORAGE_KEY_SCREEN_COUNT];
  for(let key in localStorage){
    if(key.indexOf(Global.getAppName()) === 0 && cacheList.indexOf(key) >= 0){
      localStorage.removeItem(key);
    }
  }
};

auth.clearJwtToken = function(removeTemp = true) {
		localStorage.removeItem(Constants.STORAGE_KEY_JWT_TOKEN);
		localStorage.removeItem(Constants.STORAGE_KEY_REFRESH_TOKEN);
		sessionStorage.removeItem(Constants.STORAGE_KEY_JWT_TOKEN);
		sessionStorage.removeItem(Constants.STORAGE_KEY_REFRESH_TOKEN);
		if(removeTemp){
      sessionStorage.removeItem(Constants.STORAGE_KEY_TEMP_JWT_TOKEN);
      sessionStorage.removeItem(Constants.STORAGE_KEY_TEMP_REFRESH_TOKEN);
    }
};

auth.setRememberUser = function(flag) {
	if (flag) {
		localStorage.setItem(Constants.STORAGE_KEY_REMEMBER_ME, 'Y');
	} else {
		localStorage.setItem(Constants.STORAGE_KEY_REMEMBER_ME, 'N');
	}
};

auth.getRememberUser = function() {
	let flag = localStorage.getItem(Constants.STORAGE_KEY_REMEMBER_ME);
	if (flag === 'Y') {
		return true;
	} else {
		return false;
	}
};
auth.getJwtToken = function() {
	return Global.getJwtToken();
};

auth.setJwtToken = function(token) {
  Global.setJwtToken(token);
};

auth.setRefreshToken = function(token) {
  Global.setRefreshToken(token);
};

auth.getRefreshToken = function() {
	return Global.getRefreshToken();
};

auth.exit = function() {
  Logger.insertLogs();
  let logoutPage = Constants.HOME_PAGE_LOGIN;
  if(Global.getCustomConfig()['LOGOUT_PAGE']) { // 自定义了退出页面的以自定义的为主，没有自定义的区分是密码登录还是授权码登录
    logoutPage = Global.getCustomConfig()['LOGOUT_PAGE'];
  }else if(Global.getCustomConfig()['CAS_LOGIN'] == 'ONLY'){
    let url = location.origin + location.pathname + '?type=cas';
    const returnUri = encodeURIComponent(url);
    logoutPage = `${Global.getBaseUrl()}/auth/logout?json=0&returnUri=${returnUri}`;
    if(Global.getCustomConfig()['LOGOUT_URL']){
      logoutPage = `${Global.getCustomConfig()['LOGOUT_URL']}/auth/logout?json=0&returnUri=${returnUri}`;
    }
  }
	if(Global.isPopUp()){
    if(Global.isAppPortalWebview()){
      auth.clearJwtToken();
      window.location.href = Util.getFullUrl(logoutPage);
    } else if(Global.isPreloadMode() && Util.isInstalledChromeExtension()){
      if(Global.getScreenCount() >= 2){
        this.clearJwtToken();
        let windows = Global.getWindows();
        windows.forEach(win => {
          win.url = logoutPage;
        });
        Util.openWindows(windows);
      } else {
        if(Global.isPrimaryWindow()){
          let noPrimaryWindows = Global.getNoPrimaryWindows();
          let subWindows = Global.getSubWindows();
          let windows = subWindows.concat(noPrimaryWindows);
          for(let i = 0; i < windows.length; i++){
            let winParams = {
              action: 'closeWindow',
              appId: Util.getAppId(),
              closeWindowId: windows[i].windowId
            };
            console.log('winParams>>>>', winParams);
            let event = document.createEvent('CustomEvent');
            event.initCustomEvent('closeWindow', false, false, winParams);
            document.dispatchEvent(event);
          }
          auth.clearJwtToken();
          window.location.href = Util.getFullUrl(logoutPage);
        } else {
          postMessage(Constants.EVENT_BUS_CODE_LOGOUT);
        }
      }
		} else {
      Util.openWindows([{
        windowId: Constants.WIN_LOGIN,
        url: logoutPage,
        primary: true
      }]);
      if(Util.isInstalledChromeExtension()){
        this.clearJwtToken();
        let noPrimaryWindows = Global.getWindows();
        let subWindows = Global.getSubWindows();
        let windows = subWindows.concat(noPrimaryWindows);
        for(let i = 0; i < windows.length; i++){
          let winParams = {
            action: 'closeWindow',
            appId: Util.getAppId(),
            closeWindowId: windows[i].windowId
          };
          let event = document.createEvent('CustomEvent');
          event.initCustomEvent('closeWindow', false, false, winParams);
          document.dispatchEvent(event);
        }
      }else{
        postMessage(Constants.EVENT_BUS_CODE_CLOSE_ALL_WIN, {exit: true}, null, true);
        window.close();
      }
		}
	}else{
    postMessage(Constants.EVENT_BUS_CODE_CLOSE_ALL_WIN, {exit: true}, null, true);
		auth.clearJwtToken();
		location.href = Util.getFullUrl(logoutPage);
    if(Util.isIE()){
      location.reload();
    }
	}
};

auth.isForceUpdatePwd = function () {
  let userInfo = this.getUserInfo();
  if(Global.getCustomConfig()['KIAF_FORCE_UPDATE_PWD'] === 'Y' && userInfo && Util.decrypt(userInfo.password) == userInfo.code){
    return true;
  } else {
    return false;
  }
};

auth.getRedirectUrl = function () {
  let url = '';
  if(location.hash){
    let arr = location.hash.split('#');
    if(arr && arr.length >= 2){
      url = arr[1];
    }
  }
  return url;
};

auth.nextRouter = function(to, from, next){
  // 记录路由变化
  let logData = {
    type: 'route',
    route: {
      from: from.fullPath,
      to: to.fullPath
    }
  };
  Logger.addLog(logData);

  if(Util.isEmpty(this.getJwtToken()) && sessionStorage.getItem(Constants.STORAGE_KEY_TEMP_JWT_TOKEN)){
    this.setJwtToken(sessionStorage.getItem(Constants.STORAGE_KEY_TEMP_JWT_TOKEN));
  }
  if (this.isWhiteRoute(to.path)) { // 未登录且前往的页面不是登录页
    Global.updateWindowUrl(window.name, to);
    next();
  } else if ((Util.isEmpty(this.getJwtToken()) || this.isForceUpdatePwd()) && to.name !== 'login') { // 未登录且前往的页面不是登录页
    this.clearJwtToken();
    sessionStorage.setItem(Constants.STORAGE_KEY_REDIRECT_URL, this.getRedirectUrl());
    if(Global.getCustomConfig()['LOGOUT_PAGE']){
      if(Global.getCustomConfig()['LOGOUT_PAGE'].indexOf('http') == 0){//外部链接
        location.replace(Global.getCustomConfig()['LOGOUT_PAGE']);
      } else {
        let arr = Global.getCustomConfig()['LOGOUT_PAGE'].split('#');
        let nextPath = arr[arr.length - 1];
        next({
          path: nextPath
        });
      }
    } else {
      next({
        name: 'login'// home page
      });
    }
  }else if (to.name === 'login') { // 前往的页面是登录页
    if(Util.isInstalledChromeExtension() && Util.isChromeExtensionWindow()){
      this.clearJwtToken();
    }
    next();
  } else if(Util.isInstalledChromeExtension() && Global.isPopUp()){ //插件模式下，判断是否是插件窗口，只有插件窗口才可以跳转到其他路由
    let isOpenedWindow = Util.isChromeExtensionWindow();
    if(isOpenedWindow){
      Global.updateWindowUrl(window.name, to);
      next();
    }else{
      this.clearJwtToken();
      next({
        name: 'login'// home page
      });
    }
  } else {
    // 是否开启前端二次鉴权
    if (Global.getCustomConfig()['KIAF_FRONT_SECONDARY_AUTHENTICATION'] == 'Y') {
      // 检查要跳转的页面是否被允许访问
      if (isAccessiblePage(to.path)) {
        Global.updateWindowUrl(window.name, to);
        next();
      } else {
        // 当前用户访问未授权的页面，停止跳转
        Util.pagePermissionMessage();
        next(false);
      }
    } else {
      Global.updateWindowUrl(window.name, to);
      next();
    }
  }
};

// 框架的公共页面
const kiafCommonPages = [
  '/kiaf/internalPage',
  '/kiaf/webview',
  '/kiaf/log'
];
// 检查路径是否是可以访问的页面
function isAccessiblePage(path) {
  // 如果是公共页面，全部通过
  if (kiafCommonPages.includes(path)) {
    return true;
  }

  // 检查要跳转的页面是被禁止访问的
  let forbiddenRoutes = Global.getForbiddenRoutes();
  if (forbiddenRoutes && forbiddenRoutes.length > 0) {
    return !forbiddenRoutes.includes(path);
  } else {
    // forbiddenRoutes 没有数据时，所有页面都可以访问
    return true;
  }
}

auth.getSyncUser = function () {
  try{
    let strUser = localStorage.getItem(Constants.STORAGE_KEY_USER);
    let user = {};
    if (strUser) {
      user = JSON.parse(localStorage.getItem(Constants.STORAGE_KEY_USER));
    }
    return user;
  }catch (e) {
    return {};
  }
};
auth.getUser = async function (forceUpdate = false) {
  try{
    let strUser = localStorage.getItem(Constants.STORAGE_KEY_USER);
    let user = {};
    if (strUser && !forceUpdate) {
      user = JSON.parse(localStorage.getItem(Constants.STORAGE_KEY_USER));
      return user;
    } else {
      let result = await userInfoApi({});
      if(result.user){
        user = result.user;
        if(user.loginPolicy === 'strong'){
          user.loginPolicy = 2;
        } else if(user.loginPolicy === 'middle'){
          user.loginPolicy = 1;
        } else {
          user.loginPolicy = 0;
        }
        localStorage.setItem(Constants.STORAGE_KEY_USER, JSON.stringify(user));
      }
      return user;
    }
  }catch (e) {
    return {};
  }
};

auth.getFunctionList = async function () { //获取所有授权的功能资源
  try{
    if(!this.menuList){
      this.menuList = await menuApi({noCache: true});
    }
    let functionList = [];
    this.deepSearch(this.menuList, functionList);
    return functionList;
  }catch (e) {
    return {};
  }
};
auth.deepSearch = function(menuList, functionList){
  for (let i = 0; i < menuList.length; i++) {
    let menu = menuList[i];
    if(Global.getCustomConfig()['KIAF_FUNCTION_TYPE'] && menu.type === Global.getCustomConfig()['KIAF_FUNCTION_TYPE']){
      functionList.push(menu);
    }
    if(menu.children){
      this.deepSearch(menu.children, functionList);
    }
  }
};

/**
 *
 * @param imgurl
 * @param fileName
 */
auth.downloadWatermarkImage = function (imgurl, fileName) {
  let watermarkTxt = Global.getWatermarkTxt();
  if(imgurl && imgurl.toLowerCase().indexOf('http') == 0){
    let config = {
      headers: {
        'Content-Type': 'application/json',
        'jwt-token': this.getJwtToken()
      },
      fileType: 'image/png'
    };
    if(fileName){
      config.fileName = fileName;
    }
    if(Global.getCustomConfig()['KIAF_WATERMARK_IMAGE'] && watermarkTxt){ // KIAF_WATERMARK_IMAGE 配置用于避免后台没有同步升级waterMark/add接口，导致出错
      let imageAddr = imgurl;
      let suffix = imageAddr.substring(imageAddr.lastIndexOf('.') + 1);
      let legalSufffixList = ['jpeg', 'jpg', 'png'];
      if(legalSufffixList.indexOf(suffix.toLowerCase()) < 0){
        suffix = 'png';
      }
      let url = Global.getBaseUrl() + '/waterMark/add?value=' + encodeURIComponent(watermarkTxt) + '&suffix=' + suffix.toLowerCase() + '&imageAddr=' + encodeURI(imageAddr);
      if(Global.getCustomConfig()['KIAF_WATERMARK_IMAGE'] == 'POST'){ //默认是get请求
        config.method = 'POST';
        config.body = {
          value: watermarkTxt,
          suffix: suffix.toLowerCase(),
          imageAddr: imageAddr
        }
        url = Global.getBaseUrl() + '/waterMark/add';
        // url = 'http://192.168.8.93:8095/waterMark/add';
      }
      Util.downloadFile(url, config);
      // Util.downloadFile(Global.getBaseUrl() + '/waterMark/add?value=' + encodeURIComponent(watermarkTxt) + '&suffix=' + suffix.toLowerCase() + '&imageAddr=' + encodeURI(imageAddr), config);
    } else {
      delete config.headers;
      Util.downloadFile(imgurl, config);
    }
  }else if(imgurl && imgurl.toLowerCase().indexOf('data:') == 0){
    let imageValue = imgurl.substring('data:image/png;base64,'.length);
    let body = {
      name: '',
      base64: true,
      imageValue: imageValue
    };
    let config = {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'jwt-token': this.getJwtToken()
      },
      body: body,
      fileType: 'image/png',
      fileName: new Date().getTime() + '.png'
    };
    if(fileName){
      config.fileName = fileName;
    }
    if(Global.getCustomConfig()['KIAF_WATERMARK_IMAGE'] && watermarkTxt){ // KIAF_WATERMARK_IMAGE 配置用于避免后台没有同步升级waterMark/add接口，导致出错
      Util.downloadFile(Global.getBaseUrl() + '/waterMark/base64/stream?waterMarkContent=' + encodeURIComponent(watermarkTxt) + '&suffix=jpg', config);
    } else {
      delete config.headers;
      Util.downloadFile(imgurl, config);
    }
  }else{
    console.error('imgurl>>>', imgurl);
    Util.errorMessage('无法下载图片');
  }
};

auth.online = function() {
  localStorage.setItem(Constants.STORAGE_KEY_USER_ONLINE, true);
};

auth.getUserOnline = function() {
  return localStorage.getItem(Constants.STORAGE_KEY_USER_ONLINE) || false;
};

auth.offline = function() {
  localStorage.removeItem(Constants.STORAGE_KEY_USER_ONLINE);
};

auth.addFreshEvent = function(callback = () => {}) {
  window.addEventListener('unload', e => {
    // window.name = window.name.replace(/\$reloadTime\$=\d+;/, '') + ('$reloadTime$=' + Date.now() + ';');
    if(!Global.isSubWindow()){
      sessionStorage.setItem(Constants.STORAGE_KEY_TEMP_JWT_TOKEN, this.getJwtToken());
      sessionStorage.setItem(Constants.STORAGE_KEY_TEMP_REFRESH_TOKEN, this.getRefreshToken());
      this.clearJwtToken(false);
      localStorage.removeItem(Constants['STORAGE_KEY_USER_ONLINE']);
    }
    localStorage.removeItem(Global.getSessionWindowId() + '_WINDOW_OPENED_WHITELIST');
  });

  let loadedFn = () => {
    // let reloadTime = +(window.name.match(/\$reloadTime\$=(\d+);/) || [])[1];
    // window.name = window.name.replace(/\$reloadTime\$=\d+;/, '');
    // if(isNaN(reloadTime)) return;
    localStorage.setItem(Constants['STORAGE_KEY_USER_ONLINE'], true);
    this.setJwtToken(sessionStorage.getItem(Constants.STORAGE_KEY_TEMP_JWT_TOKEN));
    this.setRefreshToken(sessionStorage.getItem(Constants.STORAGE_KEY_TEMP_REFRESH_TOKEN));
    localStorage.setItem(Global.getSessionWindowId() + '_WINDOW_OPENED_WHITELIST', true);
    callback();
  };

  if(window.document.readyState === 'complete') {
    loadedFn();
  } else {
    window.document.addEventListener('DOMContentLoaded', loadedFn);
  }
};

auth.kickUserOtherClient = async function() {
  // 配置了单客户端登录的，发个消息给服务端，尝试踢一下其他客户端
  if(Global.getCustomConfig()['CAS_SINGLE_CLIENT'] === 'Y') {
    const user = this.getUserInfo();
    const jwtToken = this.getJwtToken();
    if(!user || !jwtToken) { return false; }
    const onlineUser = { user: user.username, username: user.username };
    const bcMessage = {action: 'kick-client', kickType: 'jwt', jwtToken};
    Object.assign(onlineUser, { lockTime: 0, broadcast: true, bcMessage: JSON.stringify(bcMessage) });
    await kickOnlineUserApi(onlineUser);
    return true;
  }
  return true;
};

auth.getDepartment = async function(cusParams = {}) {
  if(!this.deptMapping){
    this.deptMapping = {};
  }
  let params = {
    paging: false
  };
  let paramsKey = '';
  for(let key in cusParams){
    params[key] = cusParams[key];
  }
  for(let key in params){
    paramsKey += key + '=' + params[key] + '&';
  }
  if(!this.deptMapping[paramsKey]){
    const result = await departmentApi(params);
    this.deptMapping[paramsKey] = result || [];
  }
  return this.deptMapping[paramsKey];
};

auth.genWebviewParams = function (activedMenu) {
  let params = {
    id: 0,
    url: '',
    sign: '',
    external: false,
    internal: false
  };
  params.sign = activedMenu.sign;
  params.id = activedMenu.id;
  params.url = Util.getFullUrl(activedMenu.url);
  if(activedMenu.webviewUrl){
    params.url = Util.getFullUrl(activedMenu.webviewUrl);
  }
  let username = this.getUserInfo().username;
  let parentAppHost = Util.getHost();
  if(Global.getCustomConfig()['KIAF_CROSS_BROADCAST'] === 'Y'){
    parentAppHost = Util.getHost() + '/static/kiaf-baseui/crossBroadcast.html';
  }
  let query = 'jwt_token=' + this.getJwtToken() + '&refresh_token=' + this.getRefreshToken() + '&username=' + username + '&parent_app_host=' + encodeURIComponent(parentAppHost) + '&kiaf_theme=' + Util.getTheme();
  if(activedMenu.webview.toLowerCase() === 'appportal'){
    query = 'append_params=Y&popup=N&webview_mode=appportal&' + query;
  }
  if(!activedMenu.noJwtToken || activedMenu.noJwtToken != 'Y'){
    if(params.url.indexOf('?') < 0){
      params.url = params.url + '?' + query;
    } else {
      params.url = params.url + '&' + query;
    }
  }

  if(activedMenu.webview.toLowerCase() === 'appportal'){
    //
  } else if(activedMenu.webview.toLowerCase() === 'internal'){
    params.internal = true;
    // params.url += '&webview_mode=internal';
    if(params.url.indexOf('?') < 0){
      params.url = params.url + '?webview_mode=internal';
    } else {
      params.url = params.url + '&webview_mode=internal';
    }
  } else {
    params.external = true;
    params.url += '&webview_mode=external';
  }
  return params;
}
export default auth;
